import React, { useState, ChangeEvent } from 'react';
import Editor from '../../editor/Editor';
import { Link, useNavigate } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { Form, Button } from 'react-bootstrap';
import Loading from '../../common/Loading';
import apolloClient from "../../utils/apolloClient";
import CREATE_PAGE_MUTATION from './queries/CREATE_PAGE_MUTATION';
import PAGES_QUERY from "./queries/PAGES_QUERY";
import AlertDismissible from '../../common/AlertDismissible';

const CreatePage = () => {
    const navigate = useNavigate();
    const [body, setBody] = useState('');
    const [title, setTitle] = useState('');
    const [saving, setSaving] = useState(false);
    const [success, setSuccess] = useState(false);
    const getEditedData = () => {
        return {
            title,
            body,
        };
    }
    const [createPage, { loading, error }] = useMutation(CREATE_PAGE_MUTATION, {
        variables: {
            pageData: {
                ...getEditedData()
            },
        },
        onCompleted: ({addPage}) => {
            if (!addPage) return;
            const data = apolloClient.readQuery({ query: PAGES_QUERY });

            apolloClient.writeQuery({
                query: PAGES_QUERY,
                data: {
                    pages: [...data.pages, addPage],
                },
            });
            setSaving(false);
            setSuccess(true);
            navigate(`/admin/edit-page/${addPage.id}`);
        },
        errorPolicy: 'all',
    });
    const renderPage = () => {
        if (error) return <div className="mt-4 mb-4">{`Submission error! ${error.message}`} <Link to="/admin">Back</Link></div>;
        return (<Form>
            {loading && <div className="mt-4 mb-4"><Loading /></div>}
            {success && <AlertDismissible variant="success" dismissible onClose={() => setSuccess(false)} className="mt-4">Page Saved.</AlertDismissible>}
            {<Form.Group className="mt-4" id="pageTitleControl">
                <Form.Label>Title</Form.Label>
                <Form.Control onChange={(event: ChangeEvent<any>) => {
                    const changed: string = event.target.value || '';
                    setTitle(changed);
                }} placeholder="Page Title" type="text" />
            </Form.Group>}
            {<Editor onChange={(content: string) => setBody(content)} value="" className="mt-4" />}
            <Button disabled={saving || loading} variant="primary" className="mt-4" onClick={() => { createPage(); setSaving(true) }}>Create Page</Button>
        </Form>);
    };
    return <div>{renderPage()}</div>;
};

export default CreatePage;
